import React, {FC} from "react"

import {useAppRouteContext} from "@irati/utils/history"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {StatementItem} from "@irati/types"
import StatusType from "@irati/wallet/types/enums/Status"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"
import authentication from "@irati/auth"
import Spacing from "@irati/ui/src/Spacing"
import {RouterLink} from "@irati/ui/src/Link"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

import PrimaryDetails from "../PrimaryDetails"
import ExpanderItem from "../ExpanderItem"
import Wrapper from "../SecondaryDetails/Wrapper"

interface Props {
  statementItem: StatementItem
}

const CashbackTransfer: FC<Props> = ({statementItem}) => {
  const {apps} = useAppRouteContext()
  const {currency, amount, sourceUser} = statementItem.transfer || {}
  const status = sourceUser?.email === authentication.user().email ? StatusType.SPENT : StatusType.CLEARED
  const dealHeader = statementItem.transfer?.spend?.dealHeader
  const dealThumbnailImage = statementItem.transfer?.spend?.dealThumbnailImage || perkboxLogo
  const redemptionUuid = statementItem.transfer?.spend?.redemptionUuid || ""

  const primaryDetails = {
    image: dealThumbnailImage,
    title: dealHeader,
    subTitle: <FormattedMessage id="platform.btn.viewDetails" />,
    amount: amount,
    currency,
    status
  }

  return (
    <Spacing marginBottom={4}>
      <ExpanderItem
        PrimaryElement={() => <PrimaryDetails imgHeightAuto data={primaryDetails} />}
        SecondaryElement={
          <Spacing marginTop="10px">
            <Wrapper>
              <Flex alignItems="center" justifyContent="space-between" flex="1">
                {status === StatusType.SPENT ? (
                  <FormattedMessage
                    id="wallet.statementItem.cashback.secondaryDetails.spentTransaction.message"
                    values={{amount: <FormattedCurrency currency={currency} value={amount} />}}
                  />
                ) : (
                  <FormattedMessage
                    id="wallet.statementItem.cashback.secondaryDetails.approvedTransaction.message"
                    values={{amount: <FormattedCurrency currency={currency} value={amount} />}}
                  />
                )}

                {redemptionUuid && (
                  <RouterLink to={`/account/my-perks/new?redemptionUuid=${redemptionUuid}`} app={apps.PERKS} marginLeft="auto">
                    <FormattedMessage id="wallet.statementItem.cashback.secondaryDetails.viewOrderHistory" />
                    <Icon icon={IconTypes.chevronRight} />
                  </RouterLink>
                )}
              </Flex>
            </Wrapper>
          </Spacing>
        }
      />
    </Spacing>
  )
}

export {CashbackTransfer}
